import useMount from '@src/utils/hooks/use-mount';
import BaseStore from '@src/utils/store/base-store';
import { observable, action } from 'mobx';

import { useRouteMatch } from 'react-router-dom';
import request from '@src/utils/request';
import * as Scroll from 'react-scroll';
import { message } from 'antd';
import $$tracker from '@src/tracker';

class ApplyStore extends BaseStore {
  @observable isLoading = false;
  @observable pageConfig = {};

  @observable jobInfo = {};
  //测试id xishanju-test
  // @observable orgId = 'xishanju-test';

  //是否浏览
  @observable browseFlag = false;

  //浏览列表
  @observable browseList = {};

  //表单信息
  @observable
  state = {
    basicInfo: {
      //推荐码
      referralCode: '',
      flie: '',
      //姓名
      name: '',
      //手机号区号
      mobile_number: undefined,
      //手机号
      phone: '',
      //邮箱
      email: '',
      //性别
      gender: '',
      //qq号
      qq_number: '',
      //所在地
      location: '',
      //求职状态
      jobSeekingStatus: undefined
    },

    resume: undefined,

    attachments: undefined,
    flag: {
      //是否阅读协议
      agreement: false
    }
  };

  @observable nameFlag = false;

  @observable mobileNumberFlag = false;

  @observable mobileInputFlag = false;
  @observable emailFlag = false;
  @observable genderFlag = false;
  @observable qqNumberFlag = false;
  @observable locationFlag = false;
  @observable jobSeekingStatusFlag = false;

  @observable resumeFlag = false;

  @observable
  sidebar = [
    {
      id: 'applicationInformation',
      text: '申请信息'
    },
    {
      id: 'uploadFile',
      text: '上传文件'
    },
    {
      id: 'personalInformation',
      text: '个人信息'
    }
  ];

  @observable sidebarCurrentIndex = 0;

  /**
   * 手机区号
   */
  @observable phoneArea = [];

  //求职状态列表
  @observable jobSeekingStatusList = [];

  /**
   * 性别
   */
  @observable genderList = [{ label: '男生', value: '男' }, { label: '女生', value: '女' }];

  handleScroll = () => {
    const module1 = document.getElementById('applicationInformation') ? document.getElementById('applicationInformation').offsetTop : null;
    const module2 = document.getElementById('uploadFile') ? document.getElementById('uploadFile').offsetTop : null;
    const module3 = document.getElementById('personalInformation') ? document.getElementById('personalInformation').offsetTop : null;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollTop >= module3 - 150) {
      this.sidebarCurrentIndex = 2;
    } else if (scrollTop >= module2) {
      this.sidebarCurrentIndex = 1;
    } else if (scrollTop >= module1 - 50) {
      this.sidebarCurrentIndex = 0;
    }
  };

  /**
   * 跳转到特定屏
   * @param elementName 跳转id
   */
  onScrollToElement = (elementName, index) => {
    // console.log(elementName, index);

    // this.sidebarCurrentIndex = index;

    if (elementName) {
      Scroll.scroller.scrollTo(elementName, {
        duration: 500,
        delay: 0,
        smooth: false,
        offset: -150 // Scrolls to element + 50 pixels down the page
      });
    }
  };
  @action
  handleChange(list, item, value) {
    this.state[list][item] = value;

    const { name, mobile_number, phone, email, gender, qq_number, location, jobSeekingStatus } = this.state.basicInfo;
    // const { resume } = this.state;

    if (name) {
      this.nameFlag = false;
    }

    if (mobile_number) {
      this.mobileNumberFlag = false;
    }
    if (phone) {
      this.mobileInputFlag = false;
    }

    if (email) {
      this.emailFlag = false;
    }
    if (gender) {
      this.genderFlag = false;
    }

    if (qq_number) {
      this.qqNumberFlag = false;
    }

    if (location) {
      this.locationFlag = false;
    }

    if (jobSeekingStatus && this.mode === 'social') {
      this.jobSeekingStatusFlag = false;
    }
    // if (resume) {
    //   this.resumeFlag = false;
    // }
  }

  // 点击提交
  SubmitSuccess = () => {
    $$tracker.clickYltd();
    let { jobId, prior } = this.$routeMatch.query;

    const { agreement } = this.state.flag;
    if (agreement === false) {
      message.info(this.pageConfig.privacy_tips);
      return;
    }
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    // 创建一个不含 awardInfo 的 browseList 副本
    const { awardInfo, flag, ...browseListWithoutAwardInfo } = this.browseList;

    // 构建 customFields自定义数组，传入获奖经历和区号id，410064326对应获奖日期，410064325对应获奖名称，区号id 410063878 对应手机区号
    // if (this.orgId === 'xishanju-test') {
    //   const customFields = [
    //     { id: 100000165, value: this.browseList.basicInfo.mobile_number, index: 0 },
    //     { id: 100000168, value: this.browseList.basicInfo.work_value ? this.browseList.basicInfo.work_value : '', index: 0 },
    //     ...awardInfo
    //       .filter(item => item.awardName || item.awardDate)
    //       .flatMap((item, index) => [{ id: 100002177, value: item.awardDate, index }, { id: 100002176, value: item.awardName, index }])
    //   ];
    //   browseListWithoutAwardInfo.customFields = customFields;
    // } else {
    //   const customFields = [
    //     { id: 410063878, value: this.browseList.basicInfo.mobile_number, index: 0 },
    //     ...awardInfo
    //       .filter(item => item.awardName || item.awardDate)
    //       .flatMap((item, index) => [{ id: 410064326, value: item.awardDate, index }, { id: 410064325, value: item.awardName, index }])
    //   ];
    //   browseListWithoutAwardInfo.customFields = customFields;
    // }

    // const customFields = [
    //   { id: 410063779, value: this.browseList.basicInfo.qq_number, index: 0 },
    //   { id: 410063778, value: this.browseList.basicInfo.location, index: 0 },
    //   { id: 410063780, value: this.browseList.basicInfo.jobSeekingStatus, index: 0 },
    //   { id: 410063878, value: this.browseList.basicInfo.mobile_number, index: 0 }
    // ];

    let customFields = [];

    // if (this.orgId === 'xishanju-test') {
    //   customFields = [
    //     { id: 410063779, value: this.browseList.basicInfo.qq_number, index: 0 },
    //     { id: 410063778, value: this.browseList.basicInfo.location, index: 0 },
    //     { id: 410063780, value: this.browseList.basicInfo.jobSeekingStatus, index: 0 },
    //     { id: 410063878, value: this.browseList.basicInfo.mobile_number, index: 0 }
    //   ];
    // } else {
    //   customFields = [
    //     { id: 48984, value: this.browseList.basicInfo.qq_number, index: 0 },
    //     { id: 92778, value: this.browseList.basicInfo.location, index: 0 },
    //     { id: 50999, value: this.browseList.basicInfo.jobSeekingStatus, index: 0 },
    //     { id: 333477, value: this.browseList.basicInfo.mobile_number, index: 0 }
    //   ];
    // }

    if (this.orgId === 'xishanju-test') {
      customFields = [
        { id: 410063779, value: this.browseList.basicInfo.qq_number, index: 0 },
        { id: 410063778, value: this.browseList.basicInfo.location, index: 0 },
        // { id: 410063780, value: this.browseList.basicInfo.jobSeekingStatus, index: 0 },
        { id: 410063878, value: this.browseList.basicInfo.mobile_number, index: 0 }
      ];
      if (this.mode === 'social') {
        customFields.push({ id: 410063780, value: this.browseList.basicInfo.jobSeekingStatus, index: 0 });
      }
    } else {
      customFields = [
        { id: 48984, value: this.browseList.basicInfo.qq_number, index: 0 },
        { id: 92778, value: this.browseList.basicInfo.location, index: 0 },
        // { id: 50999, value: this.browseList.basicInfo.jobSeekingStatus, index: 0 },
        { id: 333477, value: this.browseList.basicInfo.mobile_number, index: 0 }
      ];
      if (this.mode === 'social') {
        customFields.push({ id: 50999, value: this.browseList.basicInfo.jobSeekingStatus, index: 0 });
      }
    }
    const recommendCode = this.browseList.basicInfo.referralCode;
    browseListWithoutAwardInfo.basicInfo = JSON.stringify(browseListWithoutAwardInfo.basicInfo);
    browseListWithoutAwardInfo.customFields = JSON.stringify(customFields);
    browseListWithoutAwardInfo.jobName = this.jobInfo?.title;
    if (recommendCode) {
      browseListWithoutAwardInfo.recommendCode = recommendCode;
    }

    request
      // .post(`jobs/${this.orgId} /${jobId}/apply`, browseListWithoutAwardInfo)
      .post(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}/${jobId}/apply`, browseListWithoutAwardInfo, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      .then(response => {
        if (DEPLOY_ENV === 'master' || DEPLOY_ENV === 'test') {
          // const currentUrl = new URL(window.location.href);
          // currentUrl.hash = '';
          // let newUrlString = currentUrl.toString().replace('apply.html', 'successfully.html');
          // newUrlString += `#/?title=${encodeURIComponent(this.jobInfo?.title)}`;
          // window.location.href = newUrlString;
          const url = this.mode === 'social' ? 'successfully.html' : 'campusSuccessfully.html';
          this.jumpPage(url, `#/?title=${encodeURIComponent(this.jobInfo?.title)}`);
        } else {
          this.redirect(`successfully?title=${encodeURIComponent(this.jobInfo?.title)}`);
        }
        this.isLoading = false;
      })
      .catch(error => {
        // console.log(error.response.data.errorMessage);
        // console.error('error', error);
        message.info(error.msg);
        this.isLoading = false;
      });
  };

  // 点击预览 并且校验
  handleSubmit = () => {
    $$tracker.clickBjyl();
    // 校验必填项
    const { name, mobile_number, phone, email, gender, qq_number, location, jobSeekingStatus } = this.state.basicInfo;
    const { agreement } = this.state.flag;
    const { resume } = this.state;
    // 定义一个通用的校验函数
    const validateField = (condition, msg, flagName, showMessage = true) => {
      // console.log(condition, msg, flagName);
      if (!condition) {
        if (msg) {
          message.info(msg);
        }
        window.scrollTo({ top: 0, behavior: 'instant' });
        this[flagName] = true;
        return false;
      }
      return true;
    };

    // 检查每个字段
    const isValid = [
      validateField(agreement, this.pageConfig.privacy_tips, 'agreementFlag'),
      validateField(resume, '', 'resumeFlag', false),
      validateField(name, '', 'nameFlag', false),
      validateField(mobile_number, '', 'mobileNumberFlag', false),
      validateField(phone, '', 'mobileInputFlag', false),
      validateField(email, '', 'emailFlag', false),
      // validateField(gender, '请填写性别', 'genderFlag', false),
      validateField(qq_number, '', 'qqNumberFlag', false),
      validateField(location, '', 'locationFlag', false),
      this.mode === 'social' ? validateField(jobSeekingStatus, '', 'jobSeekingStatusFlag', false) : true
    ].every(Boolean);

    // 如果所有校验都通过
    if (isValid) {
      if (!gender) {
        message.info('请填写性别');
        window.scrollTo({ top: 0, behavior: 'instant' });

        return;
      } else {
        this.genderFlag = true;
        this.browseFlag = true;
        this.browseList = { ...this.state };
      }
    }

    this.browseList = { ...this.state };
    // console.log(this.browseFlag);
    // console.log(this.browseList, ' this.browseList');
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  //点击编辑
  clearSelections = () => {
    $$tracker.clickYlbj();
    this.browseFlag = false;
  };

  goBack = () => {
    $$tracker.clickBjqx();
    window.history.back();
  };

  init() {
    let { jobId, prior } = this.$routeMatch.query;
    if (jobId && prior) {
      this.prior = prior;
      this.getJobDetails(jobId);
    } else {
      // this.redirect('/jobList');
    }
  }

  /**
   * 检索职位列表。
   * @param {string} zhinengId - 地区id
   * @returns {Promise<void>}
   */
  getJobDetails(jobId) {
    return request
      .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}/${jobId}`, {})
      .then(res => {
        this.jobInfo = res;
      })
      .catch(error => {
        console.error('GET 请求失败', error);
      });
  }

  // 查找具有特定 id 的 res 元素的索引
  findIndexById = (res, targetId) => {
    if (!Array.isArray(res)) {
      console.error('res 不是一个数组');
      return -1;
    }
    return res.findIndex(item => item.id === targetId);
  };

  // 将 res[index] 的 detail 数组转换为 { label: code, value: code } 格式的对象数组
  mapToLabelValue = (res, index) => {
    if (!Array.isArray(res) || index < 0 || index >= res.length) {
      return [];
    }
    return (
      res[index]?.detail.map(code => ({
        label: code,
        value: code
      })) || []
    );
  };
  // 根据 orgId 和 id 映射获取对应的数据
  getListData = (res, orgId, idMap) => {
    const { testPhoneAreaId, testJobSeekingStatusId, prodPhoneAreaId, prodJobSeekingStatusId } = idMap;
    const phoneAreaId = orgId === 'xishanju-test' ? testPhoneAreaId : prodPhoneAreaId;
    const jobSeekingStatusId = orgId === 'xishanju-test' ? testJobSeekingStatusId : prodJobSeekingStatusId;

    const phoneAreaIndex = this.findIndexById(res, phoneAreaId);
    const jobSeekingStatusIndex = this.findIndexById(res, jobSeekingStatusId);

    return {
      phoneArea: this.mapToLabelValue(res, phoneAreaIndex),
      jobSeekingStatusList: this.mapToLabelValue(res, jobSeekingStatusIndex)
    };
  };
  downList() {
    const idMap = {
      testPhoneAreaId: 410063878,
      testJobSeekingStatusId: 410063780,
      prodPhoneAreaId: 333477,
      prodJobSeekingStatusId: 50999
    };

    return request
      .get('api/ssg_recruiting_cn/v1/api-platform/v1/candidates/custom_fields', {})
      .then(res => {
        const { phoneArea, jobSeekingStatusList } = this.getListData(res, this.orgId, idMap);
        this.phoneArea = phoneArea;
        this.jobSeekingStatusList = jobSeekingStatusList;
      })
      .catch(error => {
        console.error('GET request failed', error);
      });
  }
  //获取每个下拉框列表
  // downList() {
  //   return request
  //     .get('api/ssg_recruiting_cn/v1/api-platform/v1/candidates/custom_fields', {})
  //     .then(res => {
  //       // console.log(res[25]);
  //       // return;
  //       // const mapToLabelValue = index =>
  //       //   res[index].detail.map(code => ({
  //       //     label: code,
  //       //     value: code
  //       //   }));

  //       // if (this.orgId === 'xishanju-test') {
  //       //   //测试
  //       //   this.phoneArea = mapToLabelValue(11);
  //       //   this.jobSeekingStatusList = mapToLabelValue(10);
  //       // } else {
  //       //   //正式
  //       //   this.phoneArea = mapToLabelValue(73);
  //       //   this.jobSeekingStatusList = mapToLabelValue(25);
  //       // }
  //       const findIndexById = (res, targetId) => {
  //         for (let i = 0; i < res.length; i++) {
  //           if (res[i].id === targetId) {
  //             return i;
  //           }
  //         }
  //         return -1;
  //       };

  //       const mapToLabelValue = (res, index) =>
  //         res[index]?.detail.map(code => ({
  //           label: code,
  //           value: code
  //         })) || [];

  //       if (this.orgId === 'xishanju-test') {
  //         // 测试
  //         const testPhoneAreaIndex = findIndexById(res, 410063878);
  //         const testJobSeekingStatusIndex = findIndexById(res, 410063780);
  //         this.phoneArea = mapToLabelValue(res, testPhoneAreaIndex);
  //         this.jobSeekingStatusList = mapToLabelValue(res, testJobSeekingStatusIndex);
  //       } else {
  //         // 正式
  //         const prodPhoneAreaIndex = findIndexById(res, 333477);
  //         const prodJobSeekingStatusIndex = findIndexById(res, 50999);
  //         this.phoneArea = mapToLabelValue(res, prodPhoneAreaIndex);
  //         this.jobSeekingStatusList = mapToLabelValue(res, prodJobSeekingStatusIndex);
  //       }
  //     })
  //     .catch(error => {
  //       console.error('GET request failed', error);
  //     });
  // }
  use() {
    super.use();
    this.$routeMatch = useRouteMatch();

    useMount(async () => {
      $$tracker.loadPageBjjz();

      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });

      // message.success('99999', 9999);
      // message.info('99999', 9999);

      this.init();

      // setTimeout(() => {
      //   this.isLoading = true;
      // }, 1000);

      // setTimeout(() => {
      //   this.isLoading = false;
      // }, 3000);
      window.addEventListener('scroll', this.handleScroll);

      window.__FUN_LINK_PAGE_DATA_PROMISE__.then(res => {
        const { data, status } = res;
        // console.log('data', data.pageConfig);
        // console.log(data);
        this.pageConfig = data.pageConfig;
        this.mode = data.modeConfig.mode;
        this.downList();
        this.init();
      });
    });
  }
}
export default ApplyStore;
